import {auth} from '../../servicios';
// import iziToast from "izitoast";

const usuario = {
    ndt1: 0,
    dt99: null,
    dt100: null,
    bdt: false,
};
export default {
    state: {
        status: {loggedIn: false},
        user: usuario,
        obj: usuario,
        dni: null,
    },
    mutations: {
        loginFailure(state) {
            state.status.loggedIn = false;
            state.obj = usuario;
        },
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.obj = user;
        },
        setDni(state, dni) {
            state.dni = dni;
        },
        cerrarSesion(state) {
            state.status.loggedIn = false;
            state.obj = usuario;
        },
    },
    actions: {
        regenerar({commit}) {
            return auth.renovarToken().then(
                (response) => {
                    commit('loginSuccess', response);
                    return Promise.resolve(response);
                },
                error => {
                    commit('loginFailure');
                    location.reload();
                    return Promise.reject(error);
                }
            );
        },
        cerrarSesion({commit}, formulario) {
            return auth.logout(formulario).then(
                (response) => {
                    commit('cerrarSesion');
                    return Promise.resolve(response);
                },
                error => {
                    commit('cerrarSesion');
                    return Promise.resolve(error);
                }
            )

        },
        sesionU({commit}, dto) {
            return auth.login(dto).then(
                (response) => {
                    if(response.status===200){
                        commit('setDni', dto.dt1);
                        commit('loginSuccess', response.data);
                        return Promise.resolve(response.data);
                    } else {
                        return Promise.resolve(response);
                    }
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        registerU({commit}, dto) {
            return auth.validarSMS(dto.id, dto.codigo).then(
                (user) => {
                    commit('setDni', dto.formulario.ci);
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        }
    },
    getters: {
        getUsuario: state => {
            return state.obj;
        },
        getPermiso: state => {
            return state.status.loggedIn;
        },
        getDni: state => {
            return state.dni;
        },
        getToken: state => {
            if (state.status.loggedIn)
                return `${state.obj.dt99} ${state.obj.dt100}`;
            else
                return false;
        }
    }
}
